import { Route } from "react-router-dom";
import { ProtectedRoute } from "./protected-route";
import { ROUTES_CONFIG } from "@/config/routes.config";
import AppLayout from "./layout";
import DashboardPage from "./dashboard/page";
import PlayerDBPage from "./player-db/page";
import MatchesPage from "./matches/page";
import MatchDetailPage from "./[match_id]/page";
import ClubDBPage from "./club-db/page";
import ShortlistPage from "./shortlist/page";
import LonglistPage from "./longlist/page";
import PlayerDetailPage from "./[player_id]/page";
import ClubDetailPage from "./[club_id]/page";
import ReportsPage from "./reports/page";
import TasksPage from "./tasks/page";
import UserManagementPage from "./user-management/page";
import ContactsPage from "./contacts/page";
import ContactDetailPage from "./contacts/[contact_id]/page";
import OfferedPlayerDetailPage from "./contacts/[contact_id]/[offered_player_id]/page";

export const appRoutes = (
    <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
            <Route path={ROUTES_CONFIG.APP.DASHBOARD.$path()} element={<DashboardPage />} />

            <Route path={ROUTES_CONFIG.APP.PLAYER_DB.$path()} element={<PlayerDBPage />} />
            <Route path={ROUTES_CONFIG.APP.PLAYER_DETAIL.$path()} element={<PlayerDetailPage />} />
            

            <Route path={ROUTES_CONFIG.APP.CLUB_DB.$path()} element={<ClubDBPage />} />
            <Route path={ROUTES_CONFIG.APP.CLUB_DETAIL.$path()} element={<ClubDetailPage />} />

            <Route path={ROUTES_CONFIG.APP.SHORTLIST.$path()} element={<ShortlistPage />} />
            <Route path={ROUTES_CONFIG.APP.LONGLIST.$path()} element={<LonglistPage />} />

            <Route path={ROUTES_CONFIG.APP.TASKS.$path()} element={<TasksPage />} />

            <Route path={ROUTES_CONFIG.APP.MATCHES.$path()} element={<MatchesPage />} />
            <Route path={ROUTES_CONFIG.APP.MATCH_DETAIL.$path()} element={<MatchDetailPage />} />

            <Route path={ROUTES_CONFIG.APP.REPORTS.$path()} element={<ReportsPage />} />

            <Route path={ROUTES_CONFIG.APP.CONTACTS.$path()} element={<ContactsPage />} />
            <Route path={ROUTES_CONFIG.APP.CONTACTS.DETAIL.$path()} element={<ContactDetailPage />} />
            <Route path={ROUTES_CONFIG.APP.CONTACTS.DETAIL.OFFERED_PLAYER_ID.$path()} element={<OfferedPlayerDetailPage />} />

            <Route path={ROUTES_CONFIG.APP.USER_MANAGEMENT.$path()} element={<UserManagementPage />} />

            <Route path="*" element={<div>Page not found</div>} />
        </Route>
    </Route>
)